import {state} from './state';
import Swiper from "swiper";
import bb from 'blingblingjs';
import {breakpoints} from '../../config';


if(bb('.add-to-basket')[0]){

/* -----------------------------------------------------------------
                        Preview Carousel
    ----------------------------------------------------------------- */
    if(window.innerWidth <= breakpoints.m) {
        const carousel = new Swiper(".js-el__configurator-preview-carousel", {
            slidesPerView: 1,
            pagination: {
                el: '.add-to-basket__preview-pagination',
                type: 'bullets',
            }
        });

        const thumbnails = bb('.js-fn__goto-preview-slide');

        thumbnails.on('click', e => {
            thumbnails.forEach(el => el.classList.remove('--is-active'));
            e.currentTarget.classList.add('--is-active');
            carousel.slideTo(thumbnails.indexOf(e.currentTarget));
        })
    }




     /* -----------------------------------------------------------------
                    Scroll Position related styling
    ----------------------------------------------------------------- */

    let lastScrollPos = 0;

    // Position the info popups above the footer until the bottom of the configurator is visable
   /* const positionInfoPopup = () => {

        const footer = bb('.js-el__configurator-footer')[0];
        const infoPopupContainer= bb('.js-el__configurator-info-popup-container');
        const container = bb('.js-el__add-to-basket-container')[0];

        const footerHeight = footer.offsetHeight;
        const containerFromTop = container.getBoundingClientRect().bottom;
        const windowHeight = window.innerHeight;

        if (windowHeight < containerFromTop ) { // if the footer is default position
            infoPopupContainer.forEach(el => el.style.transform = `translateY(0px)`);
        } else { // if the footer is fixed 
            const transformVal = Math.min(footerHeight, (windowHeight - containerFromTop));
            infoPopupContainer.forEach(el => el.style.transform = `translateY(${transformVal}px)`);
        }

    }
    */


    // Make the footer stick once scrolled passed
    const positionFooter = () => {
        const container = bb('.js-el__add-to-basket-container')[0];
        const footer = bb('.js-el__configurator-footer')[0];
        const endMarker = bb('.js-el__add-to-basket-end-marker')[0];
        const containerFromTop = container.getBoundingClientRect().bottom;
        const endMarkerFromTop = endMarker.getBoundingClientRect().bottom;
        const windowHeight = window.innerHeight;
        footer.classList.toggle('--is-fixed', containerFromTop < 0)
        footer.classList.toggle('--is-off-screen', windowHeight >= endMarkerFromTop)
        
    }

  /*
    const toggleMiniInfo = () => {
        const container = bb('.js-el__add-to-basket-container')[0];
        const footer = bb('.js-el__configurator-footer')[0];
        const containerFromTop = container.getBoundingClientRect().bottom;
        footer.classList.toggle('--has-mini-info', containerFromTop < 0)
        
    }

    */
 
   


    // A single requestAnimationFrame function to run the above functions on each tick (if the scroll pos has changed)
    function tick() {
        if(lastScrollPos != window.scrollY) {
            lastScrollPos = window.scrollY;
            //positionInfoPopup();
            positionFooter();
            //toggleMiniInfo();
        }

        window.requestAnimationFrame(tick);
    }
    tick()



}
